export default "__VITE_ASSET__BMZN6xhw__"